








import { defineComponent, PropType } from "@vue/composition-api";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";

interface Props {
  messages: string[];
}

export default defineComponent({
  name: "SuccessMessages",
  components: {
    Caption,
    OccButton
  },
  props: {
    messages: {
      type: Array as PropType<Props["messages"]>,
      default: []
    }
  }
});
